import { gql } from 'urql';

const gqlQuery = gql`
  query StateList {
    states {
      name
      abbreviation
    }
  }
`;

export default gqlQuery;
